import { useOrchestrators } from "@nju/data-access-portal-orchestrator";
import { useProducts } from "@nju/data-access-portal-product";
import { useServiceStatus } from "@nju/data-access-portal-service";
import {
  FSecureOrderCompletedStatus,
  OrderCTABanner,
} from "@nju/feature-portal-order";
import { FSecureServiceCTABanner } from "@nju/feature-portal-service";
import { CircleLoader } from "@nju/ui";

export function FSecureDashboardMainPage() {
  const { fsecure, fsecureReactivation } = useOrchestrators();
  const { fSecureServiceStatus } = useServiceStatus();
  const fSecureOrchestratorState = fsecure?.state;
  const products = useProducts();
  const { isProductsUndefined, hasNoProducts, hasProducts, fSecure } =
    products.fSecureProducts;
  const isFSecureOnboardingComplete = fSecureOrchestratorState === "COMPLETED";

  /**
   * This is the only tricky part.
   * products = undefined - we did not fetch products yet
   * products = [] - there is no products
   * products = [...] - we have products
   */
  if (isProductsUndefined) {
    return (
      <div className="flex justify-center">
        <CircleLoader />
      </div>
    );
  }

  return (
    <>
      <FSecureServiceCTABanner
        access={fSecure}
        anniversaryDate={products.fSecureProducts.fSecure?.anniversaryDate}
        orchestrator={fsecure}
        reactivationOrchestratorStatus={fsecureReactivation?.state}
        serviceStatus={fSecureServiceStatus}
      />
      {hasNoProducts && !isFSecureOnboardingComplete && fsecure && (
        <OrderCTABanner orchestrator={fsecure} />
      )}
      {hasProducts && fsecure && (
        <FSecureOrderCompletedStatus
          fSecure={fSecure}
          fSecureServiceStatus={fSecureServiceStatus}
        />
      )}
    </>
  );
}
